import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";

import {BaseListService} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";
import {Lookup, LookupHelpers} from "framework/services/utils.service";
import {ChartColorUtilities} from "framework/ui/charting/core/colors";

@Injectable()
export class AwsSecurityHubService extends BaseListService<Models.AwsSecurityHubFindingListRequest, Models.BatchRequest, Models.AwsSecurityHubFinding>
{
    private m_severityFilterResponses: Lookup<Promise<Models.AwsSecurityHubFindingSeverityResponse>>        = {};
    private m_productNameFilterResponses: Lookup<Promise<Models.AwsSecurityHubFindingProductNameResponse>>  = {};
    private m_regionFilterResponses: Lookup<Promise<Models.AwsSecurityHubFindingRegionResponse>>            = {};
    private m_resourceFilterResponses: Lookup<Promise<Models.AwsSecurityHubFindingResourcesResponse>>       = {};
    private m_recordStateFilterResponses: Lookup<Promise<Models.AwsSecurityHubFindingRecordStatesResponse>> = {};

    constructor(inj: Injector)
    {
        super(inj, Models.AwsSecurityHubFinding);
    }

    @ReportError
    public list(listReq: Models.AwsSecurityHubFindingListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.awsSecurityHub.listFindings(listReq);
    }


    @ReportError
    protected async getBatchResponseImpl(req: Models.BatchRequest): Promise<Models.AwsSecurityHubFindingBatchResponse>
    {
        const recordIdBatchRequest = Models.BatchRequest.newInstance(req);

        return this.domain.apis.awsSecurityHub.getFindingsBatch(recordIdBatchRequest);

    }


    protected createBatchRequest(listReq: Models.AwsSecurityHubFindingListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: ids});
    }

    public severityFiltersData(tenantId: string): Promise<Models.AwsSecurityHubFindingSeverityResponse>
    {
        return LookupHelpers.ensureBaseState(this.m_severityFilterResponses,
                                             tenantId,
                                             () => this.domain.apis.awsSecurityHub.fetchFindingsFiltersSeverity(Models.AwsSecurityHubFindingSeverityRequest.newInstance({tenant_id: tenantId})));
    }

    public productNameFiltersData(tenantId: string): Promise<Models.AwsSecurityHubFindingProductNameResponse>
    {
        return LookupHelpers.ensureBaseState(this.m_productNameFilterResponses,
                                             tenantId,
                                             () => this.domain.apis.awsSecurityHub.fetchFindingsFiltersProductName(Models.AwsSecurityHubFindingProductNameRequest.newInstance({tenant_id: tenantId})));
    }

    public regionFiltersData(tenantId: string): Promise<Models.AwsSecurityHubFindingRegionResponse>
    {
        return LookupHelpers.ensureBaseState(this.m_regionFilterResponses,
                                             tenantId,
                                             () => this.domain.apis.awsSecurityHub.fetchFindingsFiltersRegion(Models.AwsSecurityHubFindingRegionRequest.newInstance({tenant_id: tenantId})));
    }


    public resourcesFiltersData(tenantId: string): Promise<Models.AwsSecurityHubFindingResourcesResponse>
    {
        return LookupHelpers.ensureBaseState(this.m_resourceFilterResponses,
                                             tenantId,
                                             () => this.domain.apis.awsSecurityHub.fetchFindingsFiltersResource(Models.AwsSecurityHubFindingResourcesRequest.newInstance({tenant_id: tenantId})));
    }

    public recordStateFiltersData(tenantId: string): Promise<Models.AwsSecurityHubFindingRecordStatesResponse>
    {
        return LookupHelpers.ensureBaseState(this.m_recordStateFilterResponses,
                                             tenantId,
                                             () => this.domain.apis.awsSecurityHub.fetchFindingFiltersRecordState(Models.AwsSecurityHubFindingRecordStatesRequest.newInstance({tenant_id: tenantId})));
    }

    public getSeverityColor(status: Models.AwsSecurityHubSeverity)
    {
        switch (status)
        {
            case Models.AwsSecurityHubSeverity.Low:
                return ChartColorUtilities.getColorById("Severity Colors", "low").color;

            case Models.AwsSecurityHubSeverity.Medium:
                return ChartColorUtilities.getColorById("Severity Colors", "medium").color;

            case Models.AwsSecurityHubSeverity.High:
                return ChartColorUtilities.getColorById("Severity Colors", "high").color;

            case Models.AwsSecurityHubSeverity.Critical:
                return ChartColorUtilities.getColorById("Severity Colors", "critical").color;

            default:
                return ChartColorUtilities.getColorById("CoreStack", "coreStackBlue").color;
        }
    }
}
